import { t } from 'i18next';
import { Bar } from '../components/bar';
import { GraphicFrame } from '../components/graphic-frame';

// Decorative preview body for the customer step: the created B2B buyer as a verified account card.
export function CustomerGraphic() {
  return (
    <GraphicFrame>
      <div className="flex h-full flex-col justify-center gap-3 px-4 py-3.5">
        <div className="flex items-center gap-3">
          <div className="grid size-10 shrink-0 place-items-center rounded-full bg-platform-primary text-white">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="size-5"
              aria-hidden="true"
            >
              <path d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.5 20.25a7.5 7.5 0 0 1 15 0" />
            </svg>
          </div>
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <Bar className="h-2.5 w-32" />
            <Bar tone="muted" className="h-2 w-24" />
          </div>
        </div>

        <div className="flex items-center gap-2 rounded-xl bg-platform-primary/10 px-3 py-2">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="size-4 shrink-0 text-platform-primary"
            aria-hidden="true"
          >
            <path d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
          <span className="font-semibold text-[13px] text-platform-primary">
            {t('features:onboarding.components.customer_preview.account_type')}
          </span>
        </div>

        <div className="border-gray-100 border-t" />

        <div className="flex flex-col gap-1.5">
          <Bar tone="muted" className="h-2 w-full" />
          <Bar tone="muted" className="h-2 w-[78%]" />
          <Bar tone="muted" className="h-2 w-[54%]" />
        </div>
      </div>
    </GraphicFrame>
  );
}
